import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

const notify = (message, type, promise, successMsg, errorMsg) =>
  type === 'promise'
    ? toast.promise(promise, { loading: message, success: successMsg, error: errorMsg })
    : type === 'success'
    ? toast.success(message)
    : toast.error(message);

export const Toast = () => {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 5000,
        style: { fontSize: '14px', fontWeight: '500', width: 'max-content', textAlign: 'left' },
      }}
    />
  );
};

export const showToast = (message, type, promise, successMsg, errorMsg) => {
  notify(message, type, promise, successMsg, errorMsg);
};
